import { useState } from 'react';
import useSync from 'hooks/useSync';

import CommonButton from 'components/CommonButton/CommonButton';
import axiosInstance from 'apis/axiosInstance';
import SyncStatus from '../../SyncStatus/SynStatus';
import { PMS_NAME, SYNC_STATUS, ROLE } from 'utils/constants';
import LatestSyncMessage from '../LatestSyncMessage/LatestSyncMessage';
import { renderToast } from 'components/Toast/Toast';
import getIsSyncDisabled from 'pages/SyncPage/util/getIsSyncDisabled';
import { useUser } from 'context/userContext';
import InfoTooltip from 'pages/SyncPage/InfoTooltip/InfoTooltip';
import useClinic from 'hooks/useClinic';

const PMSAvailabilitySection = () => {
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const { data: clinic } = useClinic();

  const { user } = useUser();

  const { data, isLoading, mutate } = useSync();

  const isSyncDisabled = getIsSyncDisabled(
    data?.pmsAvailability,
    user.adminRole?.role === ROLE.GLOBAL_ADMIN
  );

  const handleUpdatePmsAvailability = async () => {
    setIsButtonLoading(true);
    try {
      await axiosInstance.get('/sync/pms-availabilities');
      renderToast({
        message: `Sync is in progress`,
        type: 'info',
      });
    } catch (error) {
      renderToast({
        message: 'An error has occurred. Please try again.',
        type: 'error',
      });
    }
    await mutate();
    setIsButtonLoading(false);
  };

  if (!clinic || clinic.pmsName !== PMS_NAME.OPENDENTAL) {
    return null;
  }

  return (
    <div className="py-2 border-b border-light-grey">
      <div className="flex justify-between">
        <div className="basis-[45rem]">
          <div className="flex gap-x-0.9">
            <h3 className="font-bold">
              Sync Open Dental's practitioners availabilities
            </h3>
            <InfoTooltip id={'pmsAvailability'} display={isSyncDisabled} />
          </div>
          <p className="mt-2">
            Click the Update button to sync Open Dental's practitioners
            availabilities.
          </p>
        </div>
        <div className="flex flex-col items-end">
          <CommonButton
            variant="secondary"
            className="!min-h-[3.2rem]"
            onClick={handleUpdatePmsAvailability}
            isLoading={isButtonLoading}
            disabled={
              data?.pmsAvailability?.status === SYNC_STATUS.IN_PROGRESS ||
              isLoading ||
              isSyncDisabled
            }
          >
            Update
          </CommonButton>
        </div>
      </div>
      <div className="flex flex-col gap-y-0.8 mt-2">
        <SyncStatus
          isLoading={isLoading}
          data={{
            ...data?.pmsAvailability,
            status: isButtonLoading
              ? SYNC_STATUS.IN_PROGRESS
              : data?.pmsAvailability?.status,
          }}
        />
        <LatestSyncMessage
          isLoading={isLoading}
          lastSyncAt={data?.pmsAvailability?.lastSyncAt}
          lastSuccessSyncAt={data?.pmsAvailability?.lastSuccessSyncAt}
          isUpdateMessage
        />
      </div>
    </div>
  );
};

export default PMSAvailabilitySection;
